import React, {PureComponent} from 'react';
import Snackbar from '@material-ui/core/Snackbar';

import './RoleAssignment.scss';
import axios from "axios";
import Cookies from "universal-cookie";
import {FETCH_URL} from "../../constants/ServerLinks";

export default class RoleAssignment extends PureComponent {
    constructor() {
        super();

        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.world_skey = this.cookies.get('world_skey');
        this.worldName = this.cookies.get('world_name');
        this.studentName = this.cookies.get('s_name');
        this.participantId = this.cookies.get('p_id');

        this.state = {
            requestSent: false,
            logoutRequestSent: false,
            snackMsg: 'Welcome!',
            snackOpen: false,
            snackType: 'snack-success',
            countries: [],
            roles: [],
            country: 'null',
            role: 'null',
        };

        this.fetchCountryRoles();
    }

    handleSnackClose = () => {
        this.setState({snackOpen: false});
    };

    fetchCountryRoles = () => {
        axios.get(this.fetchURL + '/api/v1/roles/', {
            params: {
                world_skey: this.world_skey,
            }
        })
            .then((response) => {
                // console.group("RoleAssignment:fetchCountryRoles");
                let countryInfo = response.data.data.countries;
                this.setState({countries: countryInfo});
                let roleInfo = Object.values(response.data.data.roles);
                this.setState({roles: roleInfo});
                // console.log(this.state.roles);
                // console.groupEnd();
            })
            .catch((error) => {
                // console.group("RoleAssignment:fetchCountryRoles");
                console.log(error.response);
                // console.groupEnd();
            });
    };

    selectCountry = (e) => {
        this.setState({country: e.target.value});
    };

    selectRole = (e) => {
        this.setState({role: e.target.value});
    };

    playGame = (e) => {
        this.setState({requestSent: true,});
        e.preventDefault();

        axios.post(this.fetchURL + '/api/v1/roles/', {
            participant_id: this.participantId,
            world_skey: this.world_skey,
            country_name: this.state.country,
            alias: this.state.role,
        })
            .then((response) => {
                // console.log(response.data);
                this.setState({requestSent: false});

                if (response.data.success) {
                    this.setState({
                        snackOpen: true,
                        snackMsg: `Authentication successful!`,
                        snackType: 'snack-success',
                    });
                    const data = response.data.data;
                    this.cookies.set('role_id', data.role.id, {maxAge: 86400});
                    this.cookies.set('country_id', data.country.id, {maxAge: 86400});
                    this.cookies.set('country_name', data.country.country_name, {maxAge: 86400});
                    this.cookies.set('role_name', data.role.role_name, {maxAge: 86400});
                    this.cookies.set('role_alias', data.role.alias, {maxAge: 86400});
                    this.cookies.set('config_number', data.world.config_number, {maxAge: 86400});
                    this.cookies.set('current_year', data.world.current_year, {maxAge: 86400});

                    window.location.reload();
                } else {
                    this.setState({
                        snackOpen: true,
                        snackMsg: response.data.message,
                        snackType: 'snack-error',
                    });
                }
            })
            .catch((error) => {
                console.log(error.response);
                this.setState({requestSent: false});
            });
    };

    leaveGame = (e) => {
        this.setState({logoutRequestSent: true,});
        e.preventDefault();

        axios.delete(this.fetchURL + '/api/v1/participants/', {
            data: {
                participant_id: this.participantId,
                world_skey: this.world_skey,
            }
        })
            .then((response) => {
                // console.log(response.data);
                this.setState({logoutRequestSent: false});

                if (response.data.success) {
                    this.setState({
                        snackOpen: true,
                        snackMsg: "Leaving Game.",
                        snackType: 'snack-success',
                    });
                    this.cookies.remove('p_id');
                    this.cookies.remove('s_name');
                    this.cookies.remove('world_id');
                    this.cookies.remove('world_name');
                    this.cookies.remove('world_skey');
                    this.cookies.remove('config_number');
                    this.cookies.remove('current_year');
                    this.cookies.remove('role_alias');

                    window.location.replace('/');
                } else {
                    this.setState({
                        snackOpen: true,
                        snackMsg: response.data.message,
                        snackType: 'snack-error',
                    });
                }
            })
            .catch((error) => {
                console.log(error.response);
                this.setState({logoutRequestSent: false});
            });
    };

    render() {
        return (
            <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
                <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    open={this.state.snackOpen}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    className={this.state.snackType}
                    autoHideDuration={5000}
                    message={<span id="message-id">{this.state.snackMsg}</span>}
                />

                <div className="flex flex-items-center flex-justify-center ra__container">
                    <div className="account__container">
                        <div className={`shadow account__wrapper`}>
                            <form className="signup_form" method="post" onSubmit={e => this.leaveGame(e)}>
                                <div className="flex flex-justify-between">
                                    <div className="container">
                                        <h3>World: {this.worldName}</h3>
                                    </div>
                                    <div className="container">
                                        <button type="submit"
                                                className="button logoutBtn"
                                                disabled={this.state.logoutRequestSent ? 'disabled' : ''}>
                                            {this.state.logoutRequestSent ? 'Exiting . . .' : 'Exit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <br/>
                            <h4 className="primaryColor">Contact Info</h4>
                            <p>Name: {this.studentName}</p>
                            <br/>
                            <form className="signup_form" method="post" onSubmit={e => this.playGame(e)}>
                                <h4>Select a country and role to play</h4>

                                <div className="formItemFull">
                                    <label
                                        ref={a => (this.labeltest = a)}
                                        className="sampleLabel"
                                        htmlFor="country"
                                    >Country
                                    </label>
                                    <select name="country" id="country"
                                            className={`input__one account__input account__dropDown`}
                                            required value={this.state.country}
                                            onChange={val => this.selectCountry(val)}>
                                        <option value="null" disabled>Select a country</option>
                                        {this.state.countries.sort().map((item, index) => {
                                            return <option value={item} key={index}>{item}</option>
                                        })}
                                    </select>
                                </div>

                                <div className="formItemFull">
                                    <label
                                        ref={a => (this.labeltest = a)}
                                        className="sampleLabel"
                                        htmlFor="role"
                                    >Role
                                    </label>
                                    <select name="role" id="role"
                                            className={`input__one account__input account__dropDown`}
                                            required value={this.state.role}
                                            onChange={val => this.selectRole(val)}>
                                        <option value="null" disabled>Select a role</option>
                                        {this.state.roles.sort(function (a, b) {
                                            const nameA = a.alias.toLowerCase(), nameB = b.alias.toLowerCase();
                                            if (nameA < nameB) //sort string ascending
                                                return -1;
                                            if (nameA > nameB)
                                                return 1;
                                            return 0 //default return value (no sorting)
                                        }).map((item, index) => {
                                            return <option value={item.alias} key={index}>{item.role_name}</option>
                                        })}
                                    </select>
                                </div>


                                <button type="submit"
                                        className="loginBtn button"
                                        disabled={this.state.requestSent ? 'disabled' : ''}>
                                    {this.state.requestSent ? 'Requesting . . .' : 'Play'}
                                </button>


                            </form>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
